<template>
    <div>
        <!-- Modal -->
        <div class="modal fade" id="editarMarcacaoModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
                <div class="modal-content" v-if="editando">
                    <div class="modal-header">
                        <h5 class="modal-title">Editar Marcação</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                    </div>
                    <div class="modal-body">
                        <az-empty-state v-if="!dados" />

                        <template v-else>

                            <procedimentos-solicitados v-model="procedimentos" :listOnly="true" :cores="cores" />

                            <div class="alert alert-danger lead d-flex justify-content-between my-3" v-if="!marcacao_ativa">
                                <span>
                                    {{ dados.ch_estado_marcacao == 'B' ? 'Bloqueado' : 'Cancelado' }}
                                </span>
                                <span v-if="dados.ch_estado_marcacao == 'B'">
                                    #{{ dados.id_bloqueio }}
                                </span>
                            </div>

                            <!-- Infusão -->
                            <div v-if="dados.infusao">
                                <div class="card mt-2 mb-0">
                                    <div class="card-header alert-info py-1 px-2">
                                        {{ dados.infusao.st_titulo }}
                                    </div>
                                    <div class="card-body p-2">
                                        <div class="form-row" v-if="dados.infusao.protocolo && dados.infusao.protocolo.receita && dados.infusao.protocolo.receita.in_ciclos">
                                            <div class="col col-12 col-md-2">
                                                <az-input sizing="sm" type="number" label="Quantidade de Ciclos" :edicao="false" v-model="dados.infusao.protocolo.receita.in_ciclos" />
                                            </div>
                                            <div class="col col-12 col-md-2">
                                                <az-input sizing="sm" type="number" label="Duração do Ciclo" :edicao="false" v-model="dados.infusao.protocolo.receita.in_duracao">
                                                    <template v-slot:buttonposb>
                                                        <div class="input-group-append">
                                                        <span class="input-group-text" id="basic-addon2">dia(s)</span>
                                                        </div>
                                                    </template>
                                                </az-input>
                                            </div>
                                            <div class="col col-12 col-md-2">
                                                <az-input sizing="sm" type="number" label="Intervalo entre os Ciclos" :edicao="false" v-model="dados.infusao.protocolo.receita.in_intervalo">
                                                    <template v-slot:buttonposb>
                                                        <div class="input-group-append">
                                                        <span class="input-group-text" id="basic-addon2">dia(s)</span>
                                                        </div>
                                                    </template>
                                                </az-input>
                                            </div>
                                            <div class="col col-12 col-md-2">
                                                <az-input sizing="sm" type="number" label="Duração da Sessão" :edicao="false" v-model="dados.infusao.protocolo.receita.in_tempo_sessao">
                                                    <template v-slot:buttonposb>
                                                        <div class="input-group-append">
                                                        <span class="input-group-text" id="basic-addon2">min</span>
                                                        </div>
                                                    </template>
                                                </az-input>
                                            </div>
                                            <div class="col col-12 col-md-2">
                                                <az-input sizing="sm" type="number" label="Ciclo" v-model="dados.in_qt_ciclo" />
                                            </div>
                                            <div class="col col-12 col-md-2">
                                                <az-input sizing="sm" type="number" label="Dia" v-model="dados.in_qt_dia" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- Fim Infusão -->

                            <div class="alert alert-secondary lead py-2" v-if="dados.nome_regiao_cd">
                                <i class="fa-solid fa-location-dot fa-fw mr-2"></i>
                                <strong>{{ dados.nome_regiao_cd }}</strong>
                            </div>

                            <div class="mt-3" v-if="!dados.paciente">
                                <cadastro-temporario v-model="dados.cadastro_temporario" :validate="validate" @selecionar="identificar_paciente" />
                            </div>

                            <div class="mt-3" v-else>
                                <div class="form-row">
                                    <div class="col col-12">
                                        <az-input
                                            label="Nome"
                                            :placeholder="dados.paciente.st_nome"
                                            :edicao="false">
                                            <template v-slot:button-pos>
                                                <div class="input-group-append">
                                                    <button class="btn btn-outline-primary" type="button" id="button-addon2" @click="perfil()">
                                                        <i class="fas fa-id-badge"></i>
                                                    </button>
                                                </div>
                                            </template>
                                        </az-input>
                                    </div>
                                </div>

                                <div class="form-row">
                                    <div class="col col-12 col-md-6">
                                        <az-input
                                            label="e-mail"
                                            type="email"
                                            :validate="validate"
                                            :edicao="marcacao_ativa"
                                            v-model="dados.paciente.cadastro.st_email" />
                                    </div>
                                    <div class="col col-12 col-md-3">
                                        <az-input
                                            label="Telefone"
                                            type="fone"
                                            :edicao="marcacao_ativa"
                                            :validate="validate"
                                            v-model="dados.paciente.cadastro.telefones.telefone" />
                                    </div>
                                    <div class="col col-12 col-md-3">
                                        <az-input
                                            label="Celular"
                                            type="fone"
                                            :edicao="marcacao_ativa"
                                            :validate="validate"
                                            v-model="dados.paciente.cadastro.telefones.celular" />
                                    </div>
                                </div>
                            </div>

                            <div class="form-row" v-if="!dados.id_atendimento">
                                <div class="col col-12">
                                    <az-input 
                                        sizing="sm"
                                        label="Operadora / Plano" 
                                        type="autocomplete" 
                                        optionsMode="aql" 
                                        :optionsParm="{ atendimento: true }"
                                        optionsName="planos.atendimento"
                                        service="planos.index" 
                                        optionsDisplay="search"
                                        :edicao="marcacao_ativa"
                                        :optionsSync="false"
                                        v-model="dados.plano"
                                        required 
                                        :validate="validate"/>
                                </div>
                            </div>

                            <az-sub-title class="mt-1" title="Observação" v-if="false" />

                            <div class="form-row">
                                <div class="col col-12">
                                    <az-input
                                        sizing="sm"
                                        label="Observação" 
                                        type="text" 
                                        v-model="dados.st_observacoes" />
                                </div>
                            </div>

                            <div class="form-row" v-if="dados.plano.id_operadora == 1 && dados.js_outros_campos && dados.js_outros_campos.link_pag !== undefined">
                                <div class="col col-12">
                                    <az-input
                                        sizing="sm"
                                        label="Link para Pagamento" 
                                        type="text" 
                                        v-model="dados.js_outros_campos.link_pag" />
                                </div>
                            </div>

                            <div class="form-row" v-if="dados.dt_checkin">
                                <div class="col col-12 col-md-6">
                                    <az-input
                                        sizing="sm"
                                        label="Recepção"
                                        type="select"
                                        :edicao="marcacao_ativa"
                                        v-if="recepcoes.length > 1"
                                        optionsData="id_recepcao"
                                        :optionsList="recepcoes"
                                        v-model="dados.id_recepcao" />
                                </div>
                            </div>

                            <div class="form-row mt-2">
                                <div class="col col-12 col-md-6">
                                    <az-input 
                                        sizing="sm"
                                        type="select" 
                                        optionsMode="aql"
                                        service="sinalizadores.index"
                                        :optionsParm="{ ativos: true }"
                                        v-model="dados.sinalizador_atendimento">
                                        <template v-slot:button-pre> 
                                            <div class="input-group-prepend">
                                                <span class="input-group-text" id="basic-addon1">
                                                    <i  :class="dados.sinalizador_atendimento 
                                                            ? ( dados.sinalizador_atendimento.st_icon ? dados.sinalizador_atendimento.st_icon : 'fas fa-flag' ) + ' text-' + dados.sinalizador_atendimento.st_cor 
                                                            : 'fas fa-question'" 
                                                        aria-hidden="true"></i>
                                                </span>
                                            </div>
                                        </template>
                                    </az-input>
                                </div>
                                <div class="col col-12 col-md-3">
                                    <az-input 
                                        sizing="sm"
                                        :edicao="!dados.id_atendimento && marcacao_ativa" 
                                        type="checkbox-group" 
                                        label="Teleatendimento" 
                                        v-model="dados.fl_tele_atendimento" />
                                </div>    

                                <div class="col col-12 col-md-3">
                                    <az-input 
                                        sizing="sm"
                                        type="checkbox-group" 
                                        label="Preferencial" 
                                        v-model="dados.fl_preferencial" />
                                </div>
                            </div>

                            <!-- Autorização -->
                            <template v-if="dados.js_autorizacao">

                                <az-sub-title title="Autorização" />

                                <div class="row">
                                    <div class="col col-12 col-md-4">
                                        <az-input
                                            label="Senha"
                                            :validate="validate"
                                            :edicao="!dados.id_atendimento && marcacao_ativa"
                                            v-model="dados.js_autorizacao.st_codigo_autorizacao" />
                                    </div>
                                    <div class="col col-12 col-md-4">
                                        <az-input
                                            type="date"
                                            label="Data de Liberação"
                                            :validate="validate"
                                            :edicao="!dados.id_atendimento && marcacao_ativa"
                                            v-model="dados.js_autorizacao.dt_autorizacao" />
                                    </div>
                                    <div class="col col-12 col-md-4">
                                        <az-input
                                            type="date"
                                            label="Validade"
                                            :validate="validate"
                                            :edicao="!dados.id_atendimento && marcacao_ativa"
                                            v-model="dados.js_autorizacao.dt_validade_autorizacao" />
                                    </div>
                                </div>

                                <medico-solicitante 
                                    :block_executante="true"
                                    :validate="validate" 
                                    :edicao="!dados.id_atendimento && marcacao_ativa"
                                    v-model="dados.js_autorizacao" />

                            </template>

                            <template v-else-if="$store.state.user.marc_ms && !dados.id_atendimento && procedimentos && procedimentos.find(item => item.procedimento && item.procedimento.id_classe_procedimento > 1)">
                                <medico-solicitante
                                    ref="medico_solic"
                                    v-model="dados"
                                    :block_executante="true"
                                    :alter_proc="false"
                                    :validate="validate" />
                            </template>

                            <!-- Informações Chapp -->
                            <div class="alert alert-success d-flex justify-content-between mt-3" v-if="dados.js_outros_campos && dados.js_outros_campos.chapp_pg">
                                <div>Pagamento App: <strong>Registrado</strong></div>
                            </div>

                            <div class="alert alert-info d-flex justify-content-between mt-3" v-else-if="dados.js_outros_campos && dados.js_outros_campos.link_pag && dados.js_outros_campos.chapp_pg === false">
                                <div>Link Pagamento App: <strong>{{ dados.js_outros_campos.link_pag }}</strong></div>
                                <div>
                                    <a href="#" @click.prevent="copiar_texto(dados.js_outros_campos.link_pag, 'Link de Pagamento copiado!')">
                                        <i class="fas fa-copy"></i>
                                    </a>
                                </div>
                            </div>

                            <!-- Campos Customizados -->
                            <div v-if="dados.campos_customizados && dados.campos_customizados.js_campos.length" class="row">
                                <div class="col col-12">
                                    <az-sub-title :title="dados.campos_customizados.st_titulo" />
                                    <formulario 
                                        :gutters="true" 
                                        v-model="dados.campos_customizados.js_campos" 
                                        :saved="true" 
                                        mode="fixed"
                                        :validate="validate"
                                        :config="true" />
                                </div>
                            </div>

                            <div class="mt-3" v-if="dados && dados.doc_pre_atend_ccs && dados.doc_pre_atend_ccs.length">
                                <pre-atendimento-edit 
                                    v-model="dados.doc_pre_atend_ccs" 
                                    :validate="validate" />
                            </div>

                            <template v-if="dados.outras && dados.outras.length">
                                <az-sub-title class="mt-3" title="Outros Atendimentos" />
                                <ul class="list-group">
                                    <li class="list-group-item" v-for="(outra, iox) in dados.outras" :key="iox">
                                        {{ outra.dt_inicio.substr(11,5) }}
                                        <i class="fa fa-caret-right mx-3" aria-hidden="true"></i>
                                        {{ outra.procedimento.search }}
                                        <i class="fa fa-caret-right mx-3" aria-hidden="true"></i>
                                        {{ outra.medico.search }}
                                    </li>
                                </ul>
                                <pre v-if="false">{{ dados.outras }}</pre>
                            </template>

                            <template v-if="( dados.js_outros_procedimentos && dados.js_outros_procedimentos.length ) || 
                                ( dados.js_consumos && dados.js_consumos.length ) || 
                                ( !dados.id_atendimento && dados.ch_estado_marcacao == 'A' )">
                                <az-sub-title title="Procedimentos Adicionais" class="mt-3">
                                    <span class="badge badge-secondary">
                                        {{ dados.js_outros_procedimentos && dados.js_outros_procedimentos.length ? dados.js_outros_procedimentos.length : 0 }}
                                    </span>
                                </az-sub-title>
                                <template v-if="dados.js_outros_procedimentos">
                                    <div class="form-row" v-for="(proced, ipx) in dados.js_outros_procedimentos" :key="ipx">
                                        <div class="col col-12">
                                            <az-input
                                                sizing="sm"
                                                :edicao="false"
                                                :value="proced.search ? proced.search : proced.st_procedimento">
                                                <template v-slot:button-pre>
                                                    <div class="input-group-prepend" v-if="!dados.id_atendimento && dados.ch_estado_marcacao == 'A'">
                                                        <button class="btn btn-outline-danger" type="button" id="button-addon1" @click="removerElemento(dados.js_outros_procedimentos, ipx)">
                                                            <i class="fa fa-minus fa-fw" aria-hidden="true"></i>
                                                        </button>
                                                    </div>
                                                </template>
                                                <template v-slot:buttonposb>
                                                    <div class="input-group-append" v-if="proced.in_quantidade > 1">
                                                        <span class="input-group-text">
                                                            x{{ proced.in_quantidade }}
                                                        </span>
                                                    </div>
                                                    <div class="input-group-append" v-if="proced.js_complementos && proced.js_complementos.length">
                                                        <button class="btn btn-sm btn-secondary dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                            {{ proced.st_regiao ? proced.st_regiao  : 'Região...' }}
                                                        </button>
                                                        <div class="dropdown-menu dropdown-menu-scroll" aria-labelledby="dropdownMenuButton">
                                                            <a class="dropdown-item" 
                                                                href="#" v-for="(regiao, irx) in proced.js_complementos" 
                                                                :key="irx"
                                                                @click.prevent="regiao_add(proced, regiao)" :class="regiao_tem(proced, regiao) ? 'active' : ''">
                                                                {{ regiao }}
                                                            </a>
                                                        </div>
                                                    </div>

                                                </template>
                                            </az-input>
                                        </div>
                                    </div>     
                                </template>
                                <template v-if="!dados.id_atendimento && dados.ch_estado_marcacao == 'A'">
                                    <az-input
                                        v-if="!dados.id_atendimento && dados.ch_estado_marcacao == 'A'"
                                        placeholder="Adicionar procedimento..."
                                        sizing="sm"
                                        icon="fas fa-plus fa-fw"
                                        type="autocomplete" 
                                        optionsMode="aql"
                                        service="procedimentos.index"
                                        :optionsParm="{
                                            agenda: true, 
                                            agenda_add: true, 
                                            ativos: true, 
                                            id_medico: dados.medico.id_pessoa, 
                                            id_operadora: dados.plano ? dados.plano.id_operadora : null, 
                                            id_plano: dados.plano ? dados.plano.id_plano : null, 
                                            cc: cc ? 1 : 0, 
                                            infusao: infusao ? 1 : 0, 
                                        }"
                                        :procsigla="true"
                                        v-model="novoProcedimento"
                                        ref="info_procedimento"
                                        @selecionado="incluirProcedimento()" />

                                    <!-- 
                                    <template v-if="dados.js_outros_procedimentos && dados.js_outros_procedimentos.length > 0">
                                        <div class="d-flex justify-content-between">
                                            <div class="btn-group dropup mb-2" v-if="false">
                                                <button class="btn dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
                                                    :class="marcado.slots > 1 ? 'btn-primary' : 'btn-secondary'">
                                                    Ocupar 
                                                    <template v-if="marcado.slots">
                                                        {{ marcado.slots ? marcado.slots : 1 }}
                                                        {{ marcado.slots > 1 ? 'horários' : 'horário' }} da agenda
                                                    </template>

                                                    <template v-if="marcado.slots && marcado.tam_slot">
                                                        | {{ marcado.tam_slot * ( marcado.slots ? marcado.slots : 1 )  }} min
                                                    </template>
                                                </button>
                                                <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                                    <a class="dropdown-item" href="#" @click="marcado.slots = ''" :class="!marcado.slots ? 'active' : ''">
                                                        Ocupação Padrão
                                                    </a>
                                                    <a class="dropdown-item" href="#" @click="marcado.slots = 1" :class="marcado.slots == 1 ? 'active' : ''">
                                                        Ocupar 1 horário da agenda
                                                        <template v-if="marcado.tam_slot">
                                                            | {{ marcado.tam_slot }} min
                                                        </template>
                                                    </a>
                                                    <a class="dropdown-item" href="#" v-for="idx in 17" :key="idx"
                                                        @click="marcado.slots = idx + 1" :class="marcado.slots == idx + 1 ? 'active' : ''">
                                                        Ocupar {{ idx + 1 }} horários da agenda
                                                        <template v-if="marcado.tam_slot">
                                                            | {{ marcado.tam_slot * ( idx + 1 ) }} min
                                                        </template>
                                                    </a>
                                                </div>
                                            </div>
                                            <div>
                                                <span v-if="tempo_total(marcado)" class="small">
                                                    <template v-if="!marcado.tam_slot || ( marcado.slots == Math.ceil( tempo_total(marcado) / marcado.tam_slot ) )">
                                                        <span class="text-muted">
                                                            Tempo Total Previsto: {{ tempo_total(marcado) }} min
                                                        </span>
                                                    </template>
                                                    <template v-else>
                                                        <a href="#" class="card-link" @click.prevent="marcado.slots = Math.ceil( tempo_total(marcado) / marcado.tam_slot )">
                                                            Tempo Total Previsto: {{ tempo_total(marcado) }} min | {{ Math.ceil( tempo_total(marcado) / marcado.tam_slot ) }} horários
                                                        </a>
                                                    </template>
                                                </span>
                                            </div>
                                        </div>
                                    </template>
                                    -->

                                    <div class="alert alert-primary d-flex justify-content-between mt-2 py-2" v-if="dados.ocr_codigos && dados.ocr_codigos.length">
                                        <div class="text-nowrap text-truncate">Pedido: <strong>{{ dados.ocr_codigos.join(', ') }}</strong></div>
                                        <div class="text-nowrap">
                                            <a href="#" @click.prevent="incluir_codigos(dados.ocr_codigos.join(', ') + ',')">
                                                <span class="badge badge-primary mr-2">{{ dados.ocr_codigos.length }}</span>
                                                <i class="fa-solid fa-arrow-up"></i>
                                            </a>
                                        </div>
                                    </div>
                                </template>
                                <template v-else>
                                    <span v-if="!dados.js_outros_procedimentos || !dados.js_outros_procedimentos.length">
                                        Nenhum 
                                    </span>
                                </template>

                                <az-sub-title title="Mat/Med/Taxas Adicionais" class="mt-3" />
                                <template v-if="dados.js_consumos">
                                    <div v-for="(consumo, ipx) in dados.js_consumos" :key="ipx">
                                        <az-input
                                            sizing="sm"
                                            :edicao="false"
                                            v-model="consumo.search">
                                            <template v-slot:button-pre>
                                                <div class="input-group-prepend" v-if="!dados.id_atendimento && dados.ch_estado_marcacao == 'A'">
                                                    <button class="btn btn-outline-danger" type="button" id="button-addon1" @click="removerElemento(dados.js_consumos, ipx)">
                                                        <i class="fa fa-minus fa-fw" aria-hidden="true"></i>
                                                    </button>
                                                </div>
                                            </template>
                                        </az-input>
                                    </div>     
                                </template>

                                <template v-if="!dados.id_atendimento && dados.ch_estado_marcacao == 'A'">
                                    <az-input
                                        class="mb-3"
                                        sizing="sm"
                                        icon="fas fa-cart-plus fa-fw"
                                        buttonToolTip="Incluir material, medicamento ou taxa..."
                                        type="autocomplete"
                                        optionsMode="aql"
                                        optionsName="consumo.index"
                                        service="consumo.index"
                                        :optionsParm="{ id_operadora: dados.plano ? dados.plano.id_operadora : 1 }"
                                        :optionsSync="true"
                                        placeholder="Incluir material, medicamento ou taxa..."
                                        v-model="novoComponente"
                                        @selecionado="incluirComponente ()"  />
                                </template>
                                <template v-else>
                                    <span v-if="!dados.js_consumos || !dados.js_consumos.length">
                                        Nenhum 
                                    </span>
                                </template>

                                <br><br><br><br><br>
                            </template>

                            <template v-if="dados.ch_estado_marcacao == 'B' && dados.historico_status_marcacaos">
                                <az-sub-title class="mt-1" title="Contatos" />
                                <div v-if="!dados.historico_status_marcacaos.length">
                                    Nenhum contato registrado.
                                </div>
                                <ul class="list-group" v-else>
                                    <li class="list-group-item" v-for="(contato, icx) in dados.historico_status_marcacaos" :key="icx">
                                        <div>
                                            <span>{{ contato.status_marcacao.st_status }}</span> 
                                            <span v-if="contato.dt_mudanca_status">
                                                <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                                                em {{ $util.getFormatDate(contato.dt_mudanca_status) }} {{ contato.dt_mudanca_status.substr(11,5) }}
                                            </span> 
                                            <span v-if="contato.usuario">
                                                <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                                                por {{ contato.usuario.st_login }}
                                            </span>
                                        </div>
                                        <div class="small">{{ contato.st_observacao }}</div>
                                    </li>
                                </ul>
                            </template>

                            <div v-if="dados && dados.status_confirmacao" class="alert alert-secondary mt-3 py-1">
                                {{ dados.status_confirmacao }}
                            </div>

                            <div v-if="dados && dados.usuario" class="small text-muted mt-3">
                                Marcado por: {{ dados.usuario.st_login }}, em {{ $util.getFormatDate(dados.dt_marcacao) }} às {{ dados.dt_marcacao.substr(11,5) }}
                            </div>

                            <div v-if="dados && dados.js_outros_campos && dados.js_outros_campos.id_aso_medsafe" class="small text-muted mt-3">
                                ASO MedSafe: {{ dados.js_outros_campos.id_aso_medsafe }}
                            </div>

                            <div v-if="1==0 && dados.estoque_solicitacoes && dados.estoque_solicitacoes.length">
                                <div class="card" v-for="(solic, isx) in dados.estoque_solicitacoes" :key="isx">
                                    <div class="card-header d-flex justify-content-between">
                                        <span>
                                            <strong>#{{ solic.id_estoque_solicitacao }}</strong>
                                            <span class="badge badge-secondary">{{ solic.dt_solicitacao }}</span>
                                        </span>
                                    </div>
                                    <div class="card-body">
                                        <pre>{{ dados.estoque_solicitacoes }}</pre>
                                    </div>
                                </div>
                            </div>

                        </template>
                    </div>
                    <div class="modal-footer d-flex justify-content-between">
                        <div>
                            <az-input
                                v-if="dados && !dados.id_atendimento && marcacao_ativa"
                                type="checkbox-group"
                                label="Reenviar e-mail da marcação"
                                v-model="dados.reenviar" />

                            <span v-if="dados && dados.id_atendimento" class="small text-muted" title="Número do Atendimento">
                                #{{ dados.id_atendimento }}
                            </span>

                            <div v-if="dados && dados.atendimento && dados.atendimento.medico_solicitante" class="small text-muted" title="Solicitante">
                                Por: {{ dados.atendimento.medico_solicitante.search }}
                            </div>
                        </div>
                        <div>
                            <template v-if="dados && dados.tele_link">
                                <a href="#" @click.prevent="copiar_link()" class="btn btn-outline-primary mr-2" title="Link da Marcação.">
                                    <i class="fa-solid fa-link"></i>
                                </a>
                            </template>

                            <template v-if="dados && dados.ch_estado_marcacao == 'A' && configs && !dados.id_atendimento && dados.item_status.valor != 'faltoso'">
                                <button type="button" class="btn btn-outline-danger mr-2" data-toggle2="tooltip" data-placement="top" title="Cancelar Marcação"
                                    @click="cancelar(dados)" 
                                    v-if="( dados.ch_estado_marcacao == 'A' || dados.ch_estado_marcacao == 'B' ) && !dados.id_atendimento && dados.item_status.valor != 'faltoso' &&  configs.cancelar">
                                    <i class="fas fa-minus-circle"></i>
                                </button>

                                <button type="button" class="btn btn-outline-warning mr-2" data-toggle2="tooltip" data-placement="top"
                                    v-if="( dados.ch_estado_marcacao == 'A' || dados.ch_estado_marcacao == 'B' ) && !dados.id_atendimento && dados.item_status.valor != 'faltoso' &&  configs.remarcar"
                                    title="Remarcar" @click="remarcar (dados)">
                                    <i class="fas fa-retweet"></i>
                                </button>

                                <template v-if="dados.ch_estado_marcacao == 'A' && configs.confirmar">
                                    <button type="button" class="btn btn-outline-success mr-2" data-toggle2="tooltip" data-placement="top" title="Confirmado" @click="confirmar (dados, 'C')">
                                        <i class="fas fa-phone"></i>
                                    </button>

                                    <button type="button" class="btn btn-outline-secondary mr-2" data-toggle2="tooltip" data-placement="top" title="Sem resposta" @click="confirmar (dados, 'S')">
                                        <i class="fas fa-phone-slash"></i>
                                    </button>
                                </template>
                            </template>

                            <template v-if="dados && dados.ch_estado_marcacao == 'A' && dados.dt_inicio >= $util.hoje() && !dados.id_solicitacao_autorizacao">
                                <button type="button" class="btn btn-outline-secondary mr-2" @click="ativar_autorizacao()">
                                    Autorização
                                </button>
                            </template>
                            <az-audit-log-button model="marcacao" :id="dados.id_marcacao" v-if="dados && dados.id_marcacao" />
                            <button type="button" class="btn btn-secondary mx-2" data-dismiss="modal">Fechar</button>
                            <az-submit @click="atualizar()">Atualizar</az-submit>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import AzSubmit from '../../util/AzSubmit.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';
import ProcedimentosSolicitados from './ProcedimentosSolicitados.vue';
import CadastroTemporario from './CadastroTemporario.vue';
import AzSubTitle from '../../util/AzSubTitle.vue';
import AzInput from '../../shared/forms/AzInput.vue';
import Formulario from '../consultorio/Formulario.vue';
import AzAuditLogButton from '../../util/AzAuditLogButton.vue';
import PreAtendimentoEdit from '../recepcao/PreAtendimentoEdit.vue';
import MedicoSolicitante from '../../shared/MedicoSolicitante.vue';

export default {
    data() { 
        return { 
            dados: null, 
            editando: false, 
            procedimentos: null,
            cores: ['success'],
            validate: false, 
            novoProcedimento: "", 
            novoComponente: "", 
            callback: null, 
            configs: null 
        }
    },

    components: { 
        AzSubmit,
        AzEmptyState,
        ProcedimentosSolicitados,
        CadastroTemporario, 
        AzInput,
        AzSubTitle,
        Formulario, 
        AzAuditLogButton, 
        PreAtendimentoEdit, 
        MedicoSolicitante,
    },

    props: [
        'cc', 'infusao', 
    ],

    computed: { 
        marcacao_ativa: function () { 
            if ( !this.dados )
                return true;

            return !( this.dados.ch_estado_marcacao == 'B' || this.dados.ch_estado_marcacao == 'C' );
        },

        recepcoes: function () { 
            if ( !this.dados || !this.dados.id_unidade_operacao )
                return [];

            let unid = this.$store.state.unidade.unidade_operacaos.find(item => item.id_unidade_operacao == this.dados.id_unidade_operacao);

            if ( unid ) { 
                return unid.recepcaos;
            } else { 
                return [];
            }
        },
    },

    watch: { 

        dados: {
            handler() {

                if ( this.dados && this.dados.js_autorizacao && !this.dados.js_autorizacao.medico_solicitante ) {
                    this.dados.js_autorizacao.medico_solicitante = { st_nome: "" };
                }

            },
            deep: true,
            immediate: true,
        },

    },

    methods: { 
        incluir_codigos(codigos) {
            // this.copiar_clipboard(codigos);
            this.$refs.info_procedimento.$refs.input.focus ();
            this.$refs.info_procedimento.search = codigos;
            this.$refs.info_procedimento.onChange();
        },
        
        lista_tempos(duracao) { 
            let lista = [];

            for ( let i = 10; i <= duracao; i += 5 ) { 
                lista.push(i);
            }

            return lista;
        },
        // Métodos para seleção da Região
        regiao_tem (proc, texto) { 
            if ( !proc )
                return false;

            let items = proc.st_regiao ? proc.st_regiao.split(', ') : [];
            return items.find(item => item == texto) ? true : false; 
        },

        regiao_add (proc, texto) { 
            let items = proc.st_regiao ? proc.st_regiao.split(', ') : [];

            let index = items.findIndex(item => item == texto);

            if ( index >= 0 ) { 
                items.splice(index, 1);
            } else { 
                items.push(texto);
            }
                
            proc.st_regiao = items.join(', ');
        },

        remarcar (marcacao) { 
            $('.modal').modal('hide');

            this.configs.remarcar(marcacao);
        },

        cancelar (marcacao) { 
            $('.modal').modal('hide');

            this.configs.cancelar(marcacao);
        },

        confirmar (marcacao, tipo) { 
            $('.modal').modal('hide');

            this.configs.confirmar(marcacao, tipo);
        }, 

        copiar_link () { 
            this.$util.copiar_clipboard(this, this.dados.tele_link, 'Link copiado na área de transferência.');
        },

        copiar_texto (texto, titulo) { 
            this.$util.copiar_clipboard(this, texto, titulo);
        },

        ativar_autorizacao() { 
            if ( !this.dados.js_autorizacao ) { 
                this.dados.js_autorizacao = { 
                    st_codigo_autorizacao: "", 
                    dt_autorizacao: this.$util.hoje(), 
                    dt_validade_autorizacao: this.$util.hoje(),
                    medico_solicitante: {
                        id_medico_solicitante: null,
                        st_nome: "",
                        search: "",
                        edicao: true,
                        st_numero_conselho: "",
                        id_conselho: "",
                        id_estado_conselho: "",
                        especialidade: "",
                    },
                };
            } else { 
                this.dados.js_autorizacao = null;
            }

            this.$forceUpdate();
        },

        incluirProcedimento() { 
            if ( this.novoProcedimento && Array.isArray(this.novoProcedimento) ) {
                let lista = _.cloneDeep(this.novoProcedimento);

                lista.forEach(proc => { 
                    this.novoProcedimento = proc;
                    this.incluirProcedimento();
                });
                return;
            }

            if ( this.novoProcedimento && this.dados ) { 
                if ( !this.dados.js_outros_procedimentos )
                    this.dados.js_outros_procedimentos = [];

                this.dados.js_outros_procedimentos.push({ 
                    in_quantidade: 1, 
                    id_procedimento: this.novoProcedimento.id_procedimento,
                    search: this.novoProcedimento.search,
                    js_complementos: this.novoProcedimento.js_complementos,
                    st_regiao: "", 
                    n: true,  
                });
            }

            this.novoProcedimento = null;

            this.$nextTick(() => {
                this.novoProcedimento = "";
            });
        },

        incluirComponente() {
            if ( this.novoComponente && this.dados ) {
                if ( !this.dados.js_consumos ) { 
                    this.dados.js_consumos = [];
                    this.$forceUpdate();
                }

                this.dados.js_consumos.push({
                    in_quantidade: 1,
                    id_material: this.novoComponente.id_material,
                    id_medicamento: this.novoComponente.id_medicamento,
                    id_taxa: this.novoComponente.id_taxa,
                    search: this.novoComponente.search, 
                });
            }

            this.$nextTick(() => {
                this.novoComponente = "";
            });
        },

        removerElemento(lista, index) { 
            lista.splice(index, 1);
        },
        
        identificar_paciente (id_paciente) { 

            this.$store.commit("loading", true);

            this.$util.loadItem(this, { 
                service: "pacientes",
                func: "show",
                parms: { 
                    id: id_paciente,
                }
            })
            .then(res => { 
                this.dados.paciente = res;
                this.dados.vincular_paciente = true;


                if ( this.data ) { 
                    this.selecionarPaciente(true);
                    this.$refs.instruc_conf.$forceUpdate();
                }
            })
            .finally(() => { 
                this.$store.commit("loading", false);
            });

        },

        abrir(id, callback = null, parms = null) { 

            this.callback = callback; 
            this.configs = parms;

            $('.modal').modal('hide');

            this.dados = null;
            this.procedimentos = null;
            this.editando = true;

            this.$nextTick(() => { 
                $('#editarMarcacaoModal').modal('show');
                
                this.$util.load(this, { 
                    service: 'marcacoes',
                    func: 'show',
                    with: ['medico'],
                    parms: { 
                        id: id,
                        campos_customizados: true, 
                        doc_cc: true, 
                        historico_contatos: true, 
                        buscar_outras: true, 
                        edicao: true, 
                    },
                    loadTo: res => { 
                        this.dados = res;
                        this.dados.reenviar = false;

                        if ( this.dados.outras ) { 
                            this.dados.outras = this.dados.outras.filter(item => item.id_marcacao != id);

                            if ( this.dados.outras_cad_temp ) { 
                                this.dados.outras = this.dados.outras.concat(
                                    this.dados.outras_cad_temp.filter(item => item.id_marcacao != id)
                                );
                            }

                            this.dados.outras = _.orderBy(this.dados.outras, 'dt_inicio');
                        }

                        this.procedimentos = [
                            { 
                                procedimento: res.procedimento,
                                medico: res.medico,
                                plano: res.plano,
                                data: res.dt_inicio.substr(0,10),
                                hora: res.dt_inicio.substr(11,5),
                                selected: true, 
                                unidade: null,
                                local_nome: null,  
                                st_regiao: res.st_regiao, 
                                index: 0, 
                                duracao_minutos: ( !res.id_atendimento && res.duracao_minutos > 5 ) ? res.duracao_minutos : null, 
                                id_marcacao: res.id_marcacao, 
                                procedimento_equipamentos: res.eqps, 
                            }
                        ];
                    }
                });
            });

        },

        perfil() { 
            $('.modal').modal('hide');
            this.$root.perfil(this.dados.paciente);
        },

        atualizar() { 

            let dados = _.cloneDeep(this.dados);
            dados.st_regiao = _.get(this.procedimentos,  '0.st_regiao');

            this.$util.atualizar(this, { 
                service: 'marcacoes',
                func: 'atualizar_dados',
                dados: { 
                    ...dados,
                    duracao_minutos: _.get(this.procedimentos, '0.duracao_minutos'),
                },
                modal: 'editarMarcacaoModal',
                callback: () => { 
                    this.$emit('refresh', dados);

                    if ( this.callback ) { 
                        this.callback(dados);
                    }
                }
            });

        }
    }
}
</script>